import { render, staticRenderFns } from "./ButtonFS.vue?vue&type=template&id=4da7e813&"
import script from "./ButtonFS.vue?vue&type=script&lang=ts&"
export * from "./ButtonFS.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonFS.vue?vue&type=style&index=0&id=4da7e813&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports